module.exports = __webpack_public_path__ + "img/PAUSE.6a2dc8aa.svg";